import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    position: absolute;
    right: 0px;
    top: ${displayState?.top ?? '0px'};
    background: ${displayState?.background ?? ''};
    border: ${displayState?.border ?? ''};
    border-radius: ${displayState?.borderRadius ?? ''};
    z-index: ${displayState?.zIndex ?? 10};
  `}
`;

export default Wrapper(template);